import { Helmet } from "react-helmet-async";

/**
 * SeoManager Component
 * Handles dynamic Title, Meta Description, Keywords, Open Graph, Canonical, and JSON-LD Structured Data
 */
export const SeoManager = ({ 
    title, 
    description, 
    keywords,
    schema, 
    ogTitle, 
    ogDescription, 
    ogImage, 
    ogUrl,
    canonicalUrl,
    absoluteTitle
}) => {
  // Automatically use the live dynamic URL if no canonicalUrl is provided, keeping query parameters but removing hash fragments
  const liveCanonical = canonicalUrl || (typeof window !== 'undefined' ? window.location.href.split('#')[0] : '');

    return (
        <Helmet>
            <title>{absoluteTitle ? absoluteTitle : (title ? `${title} | Researchwire Market Intelligence` : 'Researchwire Market Intelligence')}</title>
            {description && <meta name="description" content={description} />}
            {keywords && <meta name="keywords" content={keywords} />}
            {liveCanonical && <link rel="canonical" href={liveCanonical} />}
            
            <meta property="og:type" content="website" />
            {ogTitle && <meta property="og:title" content={ogTitle} />}
            {ogDescription && <meta property="og:description" content={ogDescription} />}
            {ogImage && <meta property="og:image" content={ogImage} />}
            {ogUrl && <meta property="og:url" content={ogUrl} />}
            
            {ogTitle && <meta name="twitter:card" content="summary_large_image" />}
            {ogTitle && <meta name="twitter:title" content={ogTitle} />}
            {ogDescription && <meta name="twitter:description" content={ogDescription} />}
            {ogImage && <meta name="twitter:image" content={ogImage} />}
            
            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}
        </Helmet>
    );
};

export default SeoManager;
